/**
 *
 */
(function() {
  'use strict';
  angular.module('cbl.telepass.wa.directives', ['cbl.common']);
})();



//////////////////
// WEBPACK FOOTER
// ./app/widgets/tlps.directives.js
// module id = 37
// module chunks = 0